import React, { useState, useContext } from 'react';
import { BotaoMenor, Spinner } from '../../StyledComponent';
import Cognito from '../../../Amplify';
import { Context } from '../../../services/auth';
import PassVerificationWithModal from '../../PassVerificationWithModal';
import Input from '../../Reutilizaveis/Input';
import MsgSucesso from './MsgSucesso';
import { ContextGetData } from '../../../services/getData';
import Fade from '@material-ui/core/Fade';
import changeEmailRequests from '../../../services/changeEmailRequests';
import './styles.scss';

const TrocaSenhaPrimeiroAcesso = ({ userEmail }) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [regras, setRegras] = useState(false);
  const [approved, setApproved] = useState(false);
  const [msgSuccessChangePassword, setMsgSuccessChangePassword] =
    useState(false);
  const { softImportDataHome } = useContext(ContextGetData);

  const { mudaPassword, tempPassword } = useContext(Context);

  async function logaEtrocaSenha(event) {
    setLoading(true);
    event.preventDefault();
    try {
      await Cognito.signIn(userEmail, tempPassword);

      let password = tempPassword;
      let resultChangePassword = await mudaPassword({ password, newPassword });

      if (
        resultChangePassword === 'SUCCESS' ||
        resultChangePassword === undefined
      ) {
        setLoading(false);
        setMsgSuccessChangePassword(true);
        setNewPassword('');
        setConfirmNewPassword('');

        // para confirmar o usuário e impedir que faça o primeiro acesso duas vezes
        await softImportDataHome();
        changeEmailRequests.deleteEmailBancoECognito();
      } else if (resultChangePassword === 'NotAuthorizedException') {
        setLoading(false);
      }
      return true;
    } catch (error) {
      return false;
    }
  }

  return (
    <>
      {msgSuccessChangePassword ? (
        <MsgSucesso />
      ) : (
        <Fade in>
          <div className='loginForm loginForgotPassword'>
            <div className='first-access-password centralized-column'>
              <h1>Criar senha:</h1>

              <Input
                value={newPassword}
                setValue={setNewPassword}
                placeholder='Nova senha'
                type='password'
                id='txtNewPassword'
                required='true'
                tamanho='100%'
              />

              <Input
                value={confirmNewPassword}
                setValue={setConfirmNewPassword}
                placeholder='Confirme sua senha'
                id='txtConfirmNewPassword'
                type='password'
                required='true'
                tamanho='100%'
              />

              <PassVerificationWithModal
                newPassword={newPassword}
                setApproved={setApproved}
                confirmNewPassword={confirmNewPassword}
                setRegras={setRegras}
                regras={regras}
              />

              {!regras && (
                <>
                  {loading ? (
                    <Spinner />
                  ) : (
                    <div
                      className='centralized-column'
                      style={{
                        height: '150px',
                        justifyContent: 'space-evenly',
                      }}
                    >
                      <span
                        onClick={() => {
                          setRegras(true);
                        }}
                        style={{
                          fontSize: '10px',
                          transition: '0.3s',
                          color:
                            newPassword != '' && confirmNewPassword != ''
                              ? '#B61817'
                              : '#1d3054',
                          textDecoration: 'underline',
                          cursor: 'pointer',
                          fontWeight: '900',
                        }}
                      >
                        Regras para construção da senha:
                      </span>

                      <BotaoMenor
                        className='buttonSubmit'
                        disabled={
                          (newPassword && confirmNewPassword) === '' ||
                          !approved
                            ? true
                            : false
                        }
                        type='button'
                        id='btnSaveNewPassword'
                        onClick={logaEtrocaSenha}
                      >
                        SALVAR NOVA SENHA
                      </BotaoMenor>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </Fade>
      )}
    </>
  );
};

export default TrocaSenhaPrimeiroAcesso;
